export class OrganisationDetails {

  addressLine: string = "";
  country: string = "";
  state: string = "";
  city: string = "";
  pinCode: string = "";
  phoneNumber: string = "";
  pan: string = "";
  gst: string = "";
  website: string = "";

  constructor() {
  }

}
